import Spin from 'antd/es/spin';
import { styled } from 'styled-components';

import { useSessionUser } from '../contexts/SessionUserContext';

const StyledLoadingContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  background: ${theme.colorBgContainer};
`}
`;

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

export const AuthenticatedLayout = ({ children }: AuthenticatedLayoutProps) => {
  const { userId, isInitialQueryFinished } = useSessionUser();

  // Show loading while checking authentication
  if (!isInitialQueryFinished) {
    return (
      <StyledLoadingContainer>
        <Spin size="large" />
      </StyledLoadingContainer>
    );
  }

  // If not authenticated, Whoami (now at root level) will handle the redirect
  // We just show a loading state here until the redirect happens
  if (!userId) {
    return (
      <StyledLoadingContainer>
        <Spin size="large" />
      </StyledLoadingContainer>
    );
  }

  // User is authenticated, render the children
  return <>{children}</>;
};

export default AuthenticatedLayout;
